
// export const myGetter = ( state ) => {
//  return state
// }

export const menus = ( state ) => {
 return state.menus
}

export const permissions = ( state ) => {
    return state.permissions
}